import { Snippet } from '@heroui/react';
import React, { FC } from 'react';
import { useTranslations } from '../../contexts/translation.context';

type IdViewProps = {
  children: any;
  textToCopy: any;
  className?: any;
};

const IdView: FC<IdViewProps> = ({ children, textToCopy, className }) => {
  const isPartner = window.location.pathname.startsWith('/partner');
  const { t } = useTranslations();
  return (
    <Snippet
      symbol={null}
      codeString={textToCopy}
      tooltipProps={{
        color: 'foreground',
        // disableAnimation: true,
        placement: 'right',
        closeDelay: 0,
        content: t('global.common.copyToClipboard'),
      }}
      className={`text-sm leading-5 !font-medium whitespace-nowrap inline-flex items-center ${className}`}
      classNames={{
        base: `${isPartner ? 'bg-[#E0EDFC]' : 'bg-[#F1E8FF]'} rounded-5 px-2 h-6 gap-1 py-0.5 text-sm leading-5 !font-medium whitespace-nowrap inline-flex items-center`,
        pre: `bg-transparent ${isPartner ? 'text-[#006FEE]' : 'text-[#9675CE]'} !text-sm !leading-5 !font-medium whitespace-nowrap`,
        copyButton: `${isPartner ? 'text-[#006FEE] hover:text-[#006FEE]' : 'text-[#9675CE] hover:text-[#9675CE]'} !min-w-[1.375rem] !max-w-4 h-4`,
        checkIcon: `${isPartner ? 'text-[#006FEE]' : 'text-[#9675CE]'} h-3`,
        content: 'text-sm leading-5 !font-medium whitespace-nowrap',
      }}
    >
      {children}
    </Snippet>
  );
};

export default IdView;
